<script>
export default {
    props: ['name', 'page'],
    name: "mineTitle",
    data() {
        return {};
    },
    computed: {},
    components: {
        
    },
    mounted() {},
    destroyed() {},
    watch: {},
    methods: {},
};
</script>

<template>
    <div class="mine_title flex justify_between align_center">
        <div class="name">{{ name }}</div>
        <div class="page">{{ page }}</div>
    </div>
</template>

<style scoped lang="scss">
.mine_title{
    background: #e1e4ea;
    height: .7rem;
    border-radius: .05rem;
    padding: 0 .3rem 0 .45rem;
    margin-bottom: .4rem;
    @media only screen and (max-width: 750px) {
        padding: 0 .2rem;
    }
    .name{
        font-size: .24rem;
    }
    .page{
        font-size: .16rem;
        color: #999;
    }
}
</style>